import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserStateService {
  private getInitialProfileImage(): string | null {
    return (
      sessionStorage.getItem('ProfileImage') ||
      JSON.parse(sessionStorage.getItem('userData') || '{}')?.profilePhotoUrl ||
      null
    );
  }

  private getInitialDisplayName(): string | null {
    return (
      sessionStorage.getItem('DisplayName') ||
      JSON.parse(sessionStorage.getItem('userData') || '{}')?.displayName ||
      null
    );
  }

  private profileImageSubject = new BehaviorSubject<string | null>(
    this.getInitialProfileImage()
  );
  profileImage$ = this.profileImageSubject.asObservable();

  private displayNameSubject = new BehaviorSubject<string | null>(
    this.getInitialDisplayName()
  );
  displayName$ = this.displayNameSubject.asObservable();

  setProfileImage(url: string) {
    sessionStorage.setItem('ProfileImage', url);
    this.profileImageSubject.next(url);
  }

  setDisplayName(name: string) {
    sessionStorage.setItem('DisplayName', name);
    this.displayNameSubject.next(name);
  }
}
